// extracted by mini-css-extract-plugin
module.exports = {"selectedIcon":"style_selectedIcon__1c0uBWCmOm4GT5TrpTJ3Tr","buttons":"style_buttons__2VPsFjTRbhKAaTsmfjqCHM"};